<template>
  <v-menu offset-y v-if="items.length">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="fab" color="primary" v-bind="attrs" v-on="on" :disabled="disabled" fab x-small>
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
      <v-btn v-else color="primary" v-bind="attrs" v-on="on" :disabled="disabled">
        <v-icon>{{ icon }}</v-icon>
        <v-icon></v-icon>
        <btn-title>{{ title }}</btn-title>
      </v-btn>
    </template>
    <v-list v-if="!disabled">
      <v-list-item v-for="(item, index) in items" :key="index" link @click="onClick(item)" :disabled="item.disabled">
        <v-list-item-title>{{ item.text }} <v-icon v-if="item.disabled">fas fa-lock</v-icon> </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { getAccess } from "@/components/mixings";
export default {
  mixins: [getAccess],
  props: {
    title: { type: String, default: "Результат" },
    disabled: { type: Boolean, default: false },
    items: { type: Array, default: [] },
    icon: { type: String, default: "mdi-debug-step-over" },
    status: Number,
    fab: { type: Boolean, default: false },
    data: { type: Object, default: () => {} },
  },
  computed: {},
  methods: {
    onClick(item) {
      if (item.disabled) return;
      this.$emit("click", item);
    },
  },
};
</script>
